// Menu categories offered in the Type dropdown. A hotel's existing value is
// always kept selectable even when it is not on this list (see DiningRoom),
// so editing an item can never silently drop its category.
export const cuisines = [
    "STARTERS",
    "MAIN COURSE",
    "BREADS",
    "RICE & NOODLES",
    "BREAKFAST CLASSICS",
    "EGGS",
    "ALL DAY",
    "SOUP STARTERS",
    "SALADS,RAITA & PAPAD",
    "DAL",
    "RICE",
    "NOODLES",
    "ROTIYAN",
    "BEVERAGES",
    "DESSERTS",
    "CONTINENTAL",
    "AMERICAN",
    "INDIAN",
    "INTERNATIONAL",
    "ORIENTAL",
    "OTHER OPTIONS",
];
